module.exports = __webpack_public_path__ + "static/img/mine_portrait@3x.88e0b87.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mine_portrait@3x.png
// module id = Thwf
// module chunks = 1